var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12 notification-phone-preview" }, [
    _c(
      "div",
      {
        staticClass: "notification-preview",
        class: [_vm.display === "small" ? "small" : ""],
      },
      [
        _c("img", { attrs: { src: require("@/assets/img/galaxyS10.png") } }),
        _vm._v(" "),
        _c("Notification", {
          attrs: {
            description: _vm.$t(_vm.description),
            title: _vm.$t(_vm.title),
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.display === "small"
      ? _c("div", { staticClass: "notification-phone-preview-small-footer" })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }